(() => {
  if (customElements.get('videli-oliver')) return;
  customElements.define('videli-oliver', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.t = JSON.parse(this.querySelector('[data-vo-strings]').textContent);
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.input = this.querySelector('textarea');
      this.log = this.querySelector('.vo-log');
      this.results = this.querySelector('.vo-results');
      this.status = this.querySelector('.vo-status');
      this.speech = this.querySelector('[data-speech]');
      this.detailsCache = new Map();
      this.budget = 'open'; this.budgetPending = true; this.messages = []; this.seen = new Set(); this.generation = 0; this.turns = 0;
      this.form.addEventListener('submit', e => { e.preventDefault(); this.send(this.input.value.trim()); });
      this.input.addEventListener('keydown', e => {
        if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); this.form.requestSubmit(); }
      });
      this.addEventListener('click', e => {
        const start = e.target.closest('[data-start]');
        if (start && !this.busy) this.startTopic(start.dataset.start);
        const budget = e.target.closest('[data-budget]');
        if (budget && !this.busy) this.selectBudget(budget.dataset.budget);
        const action = e.target.closest('[data-action]');
        if (!action) return;
        const name = action.dataset.action;
        if (name === 'dismiss-pet') this.dismissPet();
        if (name === 'motion') { const paused=this.dataset.motion!=='paused'; this.dataset.motion=paused?'paused':'playing'; action.setAttribute('aria-pressed',String(paused)); action.textContent=paused?this.t.resume_motion:this.t.pause_motion; }
        if (name === 'selection') this.toggleSelection();
        if (name === 'open') this.open();
        if (name === 'close') this.dialog.close();
        if (name === 'reset') this.reset();
        if (name === 'retry') this.send(this.lastAttempt, true, this.lastMore);
        if (name === 'more') this.send(this.t.more_prompt, false, true);
        if (name === 'duel' && !this.busy) this.startDuel();
        if (name === 'contact') this.contact(true);
        if (name === 'livechat') this.openChat();
        if (name === 'back') this.contact(false);
        if (name === 'duel-back') { this.duelRound = Math.max(0, this.duelRound - 1); this.duelAnswers.length = this.duelRound; this.renderDuel(); }
        if (name === 'duel-cancel') { this.querySelector('.vo-duel').hidden = true; this.dueling = false; this.dataset.dueling='false'; this.form.hidden = false; this.speech.textContent = this.t.opening; }
        const choice = e.target.closest('[data-choice]');
        if (choice && this.dueling && !this.busy) this.chooseDuel(choice.dataset.choice);
      });
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog && e.clientX < this.dialog.getBoundingClientRect().left) this.dialog.close(); });
      this.dialog.addEventListener('close', () => { this.refreshPet(); this.updateDock(); if (!this.chatHandoff && !this.widget.hidden) this.querySelector('.vo-compact').focus({preventScroll:true}); });
      this.querySelector('.vo-composer').append(this.form);
      this.dataset.pose = 'welcome';
      this.setupPresentation();
      this.setupMobileLayout();
      this.hashListener = () => { if (location.hash === '#weinberatung') this.open(); };
      window.addEventListener('hashchange', this.hashListener);
      this.hashListener();
      this.clubClass = 'vo-hide-club-' + this.id;
      const paths = (this.dataset.clubPaths || '').split(/\s+/).filter(Boolean);
      this.hideClub = this.dataset.clubMode === 'section' || (this.dataset.clubMode === 'paths' && paths.includes(location.pathname));
      if (this.hideClub) document.documentElement.classList.add('vo-hide-club');
    }
    disconnectedCallback() { this.teardownPresentation(); if(this.hideClub && ![...document.querySelectorAll('videli-oliver')].some(e=>e!==this && e.hideClub)) document.documentElement.classList.remove('vo-hide-club'); this.controller?.abort(); clearInterval(this.searchTimer); window.removeEventListener('hashchange', this.hashListener); }
    setupPresentation() {
      this.widget = this.querySelector('.vo-widget');
      this.dock = this.querySelector('.vo-dock');
      this.mobileQuery = matchMedia('(max-width: 540px)');
      this.awaitingAnswer = false;
      this.presentationObserver = new MutationObserver(() => this.updateDock());
      this.presentationObserver.observe(this.speech, {childList:true, characterData:true, subtree:true});
      this.presentationObserver.observe(this, {attributes:true, attributeFilter:['data-pose','data-busy']});
      this.heroObserver = new IntersectionObserver(entries => {
        this.heroVisible = entries[0].isIntersecting; this.updateDock();
      }, {root:this.querySelector('.vo-scroll'), threshold:0});
      this.heroObserver.observe(this.querySelector('.vo-hero'));
      try { this.introDismissed = sessionStorage.getItem('videli-oliver-intro-dismissed') === '1'; } catch {}
      this.greetDue = false;
      this.presentationTick = () => { this.refreshPet(); this.updateDock(); };
      this.delayTimer = setTimeout(() => { this.greetDue=true; this.refreshPet(); }, Math.max(0,Number(this.dataset.delay || 5))*1000);
      this.petScroll = () => {
        if (!this.greetingStarted || !(this.mobileQuery.matches || this.dataset.autoDesktop==='true')) return;
        const distance = Number(this.dataset.hideScroll || 0) / 100 * innerHeight;
        if (distance > 0 && Math.abs(scrollY-this.greetingScroll) >= distance) this.dismissPet();
      };
      window.addEventListener('scroll', this.petScroll, {passive:true});
      this.mobileQuery.addEventListener('change', this.presentationTick);
      document.addEventListener('visibilitychange', this.presentationTick);
      this.blockerObserver = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) {
          cancelAnimationFrame(this.blockerFrame); this.blockerFrame=requestAnimationFrame(()=>this.refreshPet());
        }
      });
      this.blockerObserver.observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['class','style','hidden','open','aria-hidden']});
      this.refreshPet();
    }
    visibleBlocker() {
      const visible = element => {
        const box=element.getBoundingClientRect(), css=getComputedStyle(element);
        return box.width>0 && box.height>0 && box.bottom>0 && box.top<innerHeight && css.display!=='none' && css.visibility!=='hidden' && css.opacity!=='0';
      };
      const elements=document.querySelectorAll('.sidebar--opened, dialog[open], [role="dialog"][aria-modal="true"], [data-oliver-blocker]');
      if ([...elements].some(element=>!this.contains(element)&&visible(element))) return true;
      return [...document.querySelectorAll('iframe')].some(frame=>{
        const identifiesChat=/trengo/i.test((frame.src||'')+' '+frame.id+' '+frame.title);
        const box=frame.getBoundingClientRect();
        return identifiesChat && box.width>200 && box.height>200 && visible(frame);
      });
    }
    refreshPet() {
      if (!this.widget) return;
      const paths=(this.dataset.petPaths||'').split(/\s+/).filter(Boolean);
      const permitted=(!paths.length||paths.includes(location.pathname)) && (this.mobileQuery.matches?this.dataset.mobile!=='false':this.dataset.desktop!=='false');
      const blocked=this.dialog.open || document.hidden || this.visibleBlocker();
      this.widget.hidden=!permitted||blocked;
      if (!permitted || blocked || this.introDismissed || !this.greetDue) return;
      if (!this.greetingStarted) {
        this.greetingStarted=true; this.greetingScroll=scrollY;
        this.widget.dataset.widgetState='intro';
        this.widget.querySelector('.vo-widget-intro').inert=false;
        this.widget.querySelector('.vo-compact').hidden=true;
        const seconds=Number(this.dataset.hideAfter || 0);
        if (seconds>0) this.hideTimer=setTimeout(()=>{
          this.introExpired=true;
          if(this.mobileQuery.matches || this.dataset.autoDesktop==='true') this.dismissPet();
        }, seconds*1000);
      } else if (this.introExpired && (this.mobileQuery.matches || this.dataset.autoDesktop==='true')) this.dismissPet();
    }
    dismissPet() {
      if (!this.widget) return;
      const hadFocus=this.widget.querySelector('.vo-widget-intro').contains(document.activeElement);
      this.introDismissed=true; clearTimeout(this.hideTimer);
      this.widget.dataset.widgetState='compact';
      this.widget.querySelector('.vo-widget-intro').inert=true;
      this.widget.querySelector('.vo-compact').hidden=false;
      try { sessionStorage.setItem('videli-oliver-intro-dismissed','1'); } catch {}
      if (hadFocus) this.widget.querySelector('.vo-compact').focus({preventScroll:true});
    }
    updateDock() {
      if (!this.dock) return;
      const show=this.dialog.open && !this.heroVisible && !this.dueling && this.querySelector('.vo-contact').hidden && (this.busy || this.awaitingAnswer);
      this.dock.hidden=!show;
      const target=this.querySelector('[data-dock-speech]');
      if (target.textContent!==this.speech.textContent) target.textContent=this.speech.textContent;
    }
    teardownPresentation() {
      this.mobileQuery?.removeEventListener('change', this.mobileLayoutListener);
      window.visualViewport?.removeEventListener('resize', this.viewportListener);
      window.visualViewport?.removeEventListener('scroll', this.viewportListener);
      clearTimeout(this.delayTimer); clearTimeout(this.hideTimer); cancelAnimationFrame(this.blockerFrame);
      this.heroObserver?.disconnect(); this.presentationObserver?.disconnect(); this.blockerObserver?.disconnect();
      window.removeEventListener('scroll', this.petScroll);
      this.mobileQuery?.removeEventListener('change',this.presentationTick);
      document.removeEventListener('visibilitychange',this.presentationTick);
    }
    el(tag, text, cls) { const e = document.createElement(tag); if (text != null) e.textContent = text; if (cls) e.className = cls; return e; }
    button(text, action, cls) { const b = this.el('button', text, cls); b.type = 'button'; b.dataset.action = action; return b; }
    setupMobileLayout() {
      this.selectionPanel = this.el('div', null, 'vo-selection-panel');
      this.selectionPanel.id = this.dialog.id + '-selection';
      const intro = this.querySelector('.vo-intro');
      intro.before(this.selectionPanel);
      this.selectionPanel.append(intro, this.querySelector('.vo-budget'));
      this.selectionToggle = this.button(this.t.selection_edit, 'selection', 'vo-selection-toggle');
      this.selectionToggle.setAttribute('aria-controls', this.selectionPanel.id);
      this.selectionToggle.setAttribute('aria-expanded', 'false');
      this.querySelector('.vo-composer').prepend(this.selectionToggle);
      this.originalRows = this.input.rows;
      this.mobileLayoutListener = () => {
        this.input.rows = this.mobileQuery.matches ? 1 : this.originalRows;
        this.resizeInput();
        this.updateViewport();
      };
      this.input.addEventListener('input', () => this.resizeInput());
      this.mobileQuery.addEventListener('change', this.mobileLayoutListener);
      this.viewportListener = () => { this.updateViewport(); this.resizeInput(); };
      window.visualViewport?.addEventListener('resize', this.viewportListener);
      window.visualViewport?.addEventListener('scroll', this.viewportListener);
      this.mobileLayoutListener();
    }
    focusInputOnDesktop() {
      if (!this.mobileQuery.matches) this.input.focus({preventScroll:true});
      else this.input.blur();
    }
    resizeInput() {
      if (!this.mobileQuery.matches) {
        this.input.style.removeProperty('height');
        this.input.style.removeProperty('overflow-y');
        return;
      }
      if (!this.dialog.open || this.form.hidden) return;
      const css = getComputedStyle(this.input);
      const line = parseFloat(css.lineHeight) || 24;
      const padding = parseFloat(css.paddingTop) + parseFloat(css.paddingBottom);
      const border = parseFloat(css.borderTopWidth) + parseFloat(css.borderBottomWidth);
      const maximum = line * 3 + padding + border;
      this.input.style.height = 'auto';
      const height = Math.max(44, this.input.scrollHeight + border);
      this.input.style.height = Math.min(maximum, height) + 'px';
      this.input.style.overflowY = height > maximum ? 'auto' : 'hidden';
    }
    updateViewport() {
      const viewport = window.visualViewport;
      if (this.mobileQuery.matches && viewport && viewport.scale === 1) {
        this.dialog.style.setProperty('--vo-viewport-height', viewport.height + 'px');
        this.dialog.style.setProperty('--vo-viewport-top', viewport.offsetTop + 'px');
      } else {
        this.dialog.style.removeProperty('--vo-viewport-height');
        this.dialog.style.removeProperty('--vo-viewport-top');
      }
    }
    collapseSelection() {
      this.dataset.selectionOpen = 'false';
      this.selectionToggle?.setAttribute('aria-expanded', 'false');
      if (this.selectionToggle) this.selectionToggle.textContent = this.t.selection_edit;
    }
    toggleSelection() {
      if (!this.mobileQuery.matches || this.busy || this.dueling) return;
      const expanded = this.dataset.selectionOpen !== 'true';
      this.dataset.selectionOpen = String(expanded);
      this.selectionToggle.setAttribute('aria-expanded', String(expanded));
      this.selectionToggle.textContent = expanded ? this.t.selection_close : this.t.selection_edit;
      if (expanded) {
        this.input.blur();
        requestAnimationFrame(() => {
          const scroll = this.querySelector('.vo-scroll');
          scroll.scrollTop += this.selectionPanel.getBoundingClientRect().top - scroll.getBoundingClientRect().top - 12;
        });
      }
    }
    open() {
      this.dismissPet(); this.chatHandoff = false;
      if (!this.dialog.open) {
        const close = this.querySelector('.vo-close');
        if (this.mobileQuery.matches) { this.input.blur(); close.setAttribute('autofocus', ''); }
        this.dialog.showModal();
        if (this.mobileQuery.matches) { close.focus({preventScroll:true}); close.removeAttribute('autofocus'); }
      }
      this.updateViewport(); this.resizeInput(); this.refreshPet(); this.updateDock();
      if (!this.mobileQuery.matches) this.focusInputOnDesktop();
    }
    say(role, text) { if (!text) return; const message=this.el('p', text, 'vo-message vo-message--' + role); this.log.append(message); this.latestMessage=message; }
    bottom() { requestAnimationFrame(() => { const s = this.querySelector('.vo-scroll'); const target=this.querySelector('.vo-contact:not([hidden])') || this.querySelector('.vo-duel:not([hidden])') || this.latestMessage; if(target) s.scrollTop += target.getBoundingClientRect().top - s.getBoundingClientRect().top - 12; }); }
    begin() {
      this.dataset.conversation = 'true';
      this.collapseSelection();
      this.querySelector('.vo-intro').hidden = true;
      this.querySelector('.vo-duel-invite').hidden = true;
      this.querySelector('.vo-composer').append(this.form);
      this.input.placeholder = this.t.continue_placeholder;
    }
    reset() {
      this.dataset.conversation = 'false'; this.collapseSelection();
      this.awaitingAnswer=false; this.generation++; this.controller?.abort(); clearInterval(this.searchTimer);
      this.budget='open'; this.budgetPending=true; this.querySelectorAll('[data-budget]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.budget==='open'))); this.latestMessage=null; this.messages = []; this.seen.clear(); this.turns = 0; this.lastAttempt = ''; this.dueling = false; this.dataset.dueling='false';
      this.log.replaceChildren(); this.results.replaceChildren(); this.querySelector('.vo-accessories').replaceChildren();
      for (const cls of ['vo-contact','vo-duel','vo-followups','vo-retry']) this.querySelector('.'+cls).hidden = true;
      this.querySelector('.vo-intro').hidden = false; this.querySelector('.vo-duel-invite').hidden = false;
      this.querySelector('.vo-composer').append(this.form); this.form.hidden = false;
      this.input.value = ''; this.input.placeholder = this.t.placeholder; this.resizeInput();
      this.setBusy(false); this.status.textContent = ''; this.speech.textContent = this.t.opening; this.dataset.pose = 'welcome'; this.focusInputOnDesktop();
    }
    setBusy(value) {
      this.busy = value; this.form.querySelector('button').disabled = value; this.input.disabled = value;
      this.querySelectorAll('[data-start],[data-budget],[data-action="duel"],[data-action="more"],[data-action="retry"],[data-action="selection"]').forEach(b => { b.disabled = value; });
      this.log.querySelectorAll('.vo-card button').forEach(b => { b.disabled = value || b.dataset.unavailable === 'true'; });
      this.dataset.busy = String(value);
      clearInterval(this.searchTimer); this.searchActive = false;
      if (value) {
        this.dataset.pose = 'question'; this.speech.textContent = this.t.thinking; this.status.textContent = '';
      }
    }
    startTopic(topic) {
      if(this.messages.length) return this.send(this.t['prompt_'+topic]);
      const question=this.t['question_'+topic];
      this.begin(); this.say('user',this.t['prompt_'+topic]); this.say('assistant',question);
      this.messages=[{role:'user',content:this.t['prompt_'+topic]},{role:'assistant',content:question}];
      this.awaitingAnswer=true; this.dataset.pose='question'; this.speech.textContent=this.t.listen; this.bottom(); this.focusInputOnDesktop();
    }
    selectBudget(value) {
      if (!['10','15','25','open'].includes(value)) return;
      this.budget = value; this.budgetPending = true;
      this.querySelectorAll('[data-budget]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.budget === value)));
      if (this.messages.length && !this.dueling) {
        const answer = value === 'open' ? this.t.budget_short_open : this.t.budget_short.replace('{price}',value);
        const draft = this.input.value.trim();
        this.send([draft, answer].filter(Boolean).join('\n'));
      }
    }
    searchProgress() {
      if (this.searchActive) return;
      this.searchActive = true; this.dataset.pose = 'cellar'; this.speech.textContent = this.t.search_cellar;
      this.searchTimer = setInterval(() => {
        this.dataset.pose = this.dataset.pose === 'cellar' ? 'warehouse' : 'cellar';
        this.speech.textContent = this.dataset.pose === 'cellar' ? this.t.search_cellar : this.t.search_warehouse;
      }, 3200);
    }
    async readAnswer(response, generation) {
      if (!(response.headers.get('content-type') || '').includes('application/x-ndjson')) return response.json();
      const reader = response.body.getReader(); const decoder = new TextDecoder();
      let buffer = '', result;
      const consume = line => {
        if (!line.trim()) return;
        const event = JSON.parse(line);
        if (generation !== this.generation) return;
        if (event.type === 'status' && event.phase === 'searching') this.searchProgress();
        if (event.type === 'result') result = event.data;
        if (event.type === 'error') throw new Error(this.t.error);
      };
      try {
        while (true) {
          const {value, done} = await reader.read();
          buffer += decoder.decode(value, {stream: !done});
          let newline;
          while ((newline = buffer.indexOf('\n')) >= 0) { consume(buffer.slice(0, newline)); buffer = buffer.slice(newline + 1); }
          if (done) break;
        }
        consume(buffer);
        if (!result) throw new Error(this.t.incomplete);
        return result;
      } finally { reader.releaseLock(); }
    }
    async send(content, retry = false, more = false, displayContent = content) {
      if (!content || this.busy) return;
      if (this.turns >= 24 && !retry) { this.status.textContent = this.t.session_limit; return; }
      if (!this.dataset.endpoint) { this.status.textContent = this.t.no_endpoint; return; }
      this.begin(); this.contact(false); this.dueling = false; this.dataset.dueling='false'; this.querySelector('.vo-duel').hidden = true; this.form.hidden = false;
      this.querySelector('.vo-retry').hidden = true; this.lastAttempt = content; this.lastMore = more;
      const generation = this.generation;
      const budgetContext = this.budgetPending ? (this.budget==='open' ? this.t.budget_open_context : this.t.budget_context+' '+this.budget+' '+this.t.budget_currency) : '';
      const pending = [...this.messages, { role: 'user', content: (budgetContext ? this.t.budget_preference + ' ' + budgetContext + '\n' : '') + content }];
      if (!retry) this.say('user', displayContent);
      if (this.mobileQuery.matches) this.input.blur();
      this.input.value = ''; this.resizeInput(); this.setBusy(true); this.bottom();
      const controller = new AbortController(); this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 65000);
      try {
        const response = await fetch(this.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/x-ndjson, application/json' }, body: JSON.stringify({ messages: pending, more, excluded_handles: more ? [...this.seen] : [] }), signal: controller.signal });
        if (!response.ok) throw new Error(response.status === 401 || response.status === 403 ? this.t.protected : response.status === 429 ? this.t.rate_limit : this.t.error);
        let p; try { p = await this.readAnswer(response, generation); } catch (error) { if (error instanceof SyntaxError) throw new Error(this.t.incomplete); throw error; }
        if (generation !== this.generation) return;
        if (!p || typeof p.intro !== 'string' || typeof p.clarification_required !== 'boolean' || !Array.isArray(p.recommendations) || p.recommendations.length > 6 || (p.clarification_required && (typeof p.question !== 'string' || !p.question.trim() || p.recommendations.length))) throw new Error(this.t.incomplete);
        if (p.mode === 'mock') throw new Error(this.t.mock_error);
        const text = [p.intro, p.question].filter(Boolean).join('\n\n');
        const recs = p.recommendations.filter(r => r && typeof r.handle === 'string');
        this.messages = [...pending, { role: 'assistant', content: text + '\n' + this.t.history_products + ': ' + recs.map(r=>r.handle).join(', ') }];
        this.awaitingAnswer=p.clarification_required; this.budgetPending=false; this.turns++; recs.forEach(r=>this.seen.add(r.handle));
        this.say('assistant', text); this.renderRecommendations(recs, more); this.renderAccessories(p.accessories || []);
        this.dataset.pose = p.reaction === 'off_topic' ? 'unclear' : p.clarification_required ? 'question' : recs.length ? 'result' : 'unclear';
        this.speech.textContent = p.clarification_required ? this.t.listen : recs.length ? this.t.found : this.t.consider;
        this.status.textContent = ''; this.querySelector('.vo-followups').hidden = !recs.length;
        this.querySelector('[data-action="more"]').hidden = !recs.length;
        this.lastAttempt = '';
      } catch (error) {
        if (generation !== this.generation) return;
        this.awaitingAnswer=false; this.dataset.pose = 'unclear'; this.speech.textContent = this.t.error_short;
        this.status.textContent = error.name === 'AbortError' ? this.t.timeout : error instanceof TypeError ? this.t.network_error : error.message || this.t.error;
        this.querySelector('.vo-retry').hidden = false;
      } finally {
        clearTimeout(timeout);
        if (generation === this.generation) { this.setBusy(false); this.bottom(); this.focusInputOnDesktop(); }
      }
    }
    localProduct(handle, variant) {
      const url = new URL((this.dataset.root || '/') + 'products/' + encodeURIComponent(handle), location.origin);
      if (variant) url.searchParams.set('variant', variant);
      return url.pathname + url.search;
    }
    imageURL(src) { try { const u = new URL(src, location.origin); return u.protocol === 'https:' ? u.href : ''; } catch { return ''; } }
    renderRecommendations(recs, more = false) {
      if (!recs.length) return;
      const group = this.el('section', null, 'vo-recommendation-group');
      if (more) group.append(this.el('h3', 'Weitere passende Weine'));
      const cards = this.el('div', null, 'vo-results');
      group.append(cards); this.log.append(group);
      recs.forEach(r => {
        const card = this.el('article', null, 'vo-card');
        const photo = this.el('a', null, 'vo-product-image'); photo.href = this.localProduct(r.handle, r.variant_id); photo.setAttribute('aria-label', r.title);
        const image = this.imageURL(r.image_url); if (image) { const img=this.el('img'); img.src=image;img.alt=r.title;img.width=100;img.height=160;img.loading='lazy';photo.append(img); }
        const body = this.el('div', null, 'vo-card-body');
        const heading = this.el('div', null, 'vo-card-heading'); body.append(heading);
        if (r.badge && r.badge !== 'Standard') heading.append(this.el('span',r.badge,'vo-badge'));
        const h=this.el('h3'),link=this.el('a',r.title);link.href=photo.href;h.append(link);heading.append(h);
        const meta=this.el('div',r.vendor || '', 'vo-meta');heading.append(meta);
        body.append(this.el('p',r.reason,'vo-reason'));
        const list=this.el('ul',null,'vo-points');(r.match_points || []).forEach((p,i)=>{const li=this.el('li');const icon=this.el('span',['✦','❧','◇'][i]||'✦');icon.setAttribute('aria-hidden','true');li.append(icon,document.createTextNode(p));list.append(li)});body.append(list);
        const price=this.el('strong',r.price,'vo-price'),unit=this.el('span','', 'vo-unit');body.append(price,unit);
        if (r.requested_quantity>1 || r.includes_card_in_total) body.append(this.el('p',`${r.requested_quantity || 1} × ${this.t.sale_unit} · ${this.t.total}: ${r.purchase_total}${r.includes_card_in_total ? ' · '+this.t.card_separate : ''}`,'vo-small'));
        body.append(this.el('span',this.t.tax,'vo-small')); const shipping=this.el('a',this.t.shipping,'vo-small');shipping.href=(this.dataset.root||'/')+'pages/versand-und-zahlung';body.append(shipping);
        const button=this.el('button',r.purchase_action==='product_page'?this.t.package_view:this.t.cart_add,'vo-primary');button.type='button';
        button.addEventListener('click',()=>{if(r.purchase_action==='product_page')location.assign(photo.href);else this.addToCart(button,r)});body.append(button);
        card.append(photo,body);cards.append(card);
        this.enrich(r,card,meta,price,unit,button);
      });
    }
    async enrich(r,card,meta,price,unit,button) {
      const key=r.handle+':'+r.variant_id;
      try {
        if (!this.detailsCache.has(key)) this.detailsCache.set(key,(async()=>{
          const url=new URL(this.localProduct(r.handle,r.variant_id),location.origin);url.searchParams.set('section_id','videli-sommelier-details');
          const response=await fetch(url.pathname+url.search,{credentials:'same-origin',signal:AbortSignal.timeout(10000)});
          if(!response.ok)throw Error('details');return new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-oliver-details]');
        })());
        const data=await this.detailsCache.get(key);if(!data||!card.isConnected||data.dataset.variant!==String(r.variant_id))return;
        meta.replaceChildren();const producer=data.querySelector('[data-producer]')?.textContent;if(producer)meta.append(this.el('span',producer));
        const country=data.querySelector('[data-country]')?.textContent,flag=data.querySelector('img');
        if(flag){const img=this.el('img');const src=this.imageURL(flag.src);if(src){img.src=src;img.alt=country||'';img.width=24;img.height=16;img.className='vo-flag';meta.append(img)}}
        if(country)meta.append(this.el('span',country));const rating=data.querySelector('[data-rating]')?.textContent;if(rating)meta.append(this.el('span','★ '+rating,'vo-rating'));
        const current=data.querySelector('[data-price]')?.textContent;if(current)price.textContent=current;
        unit.textContent=data.querySelector('[data-unit]')?.textContent||'';
        if(data.dataset.available==='false'){button.disabled=true;button.dataset.unavailable='true';button.textContent=this.t.unavailable}
      } catch { this.detailsCache.delete(key); }
    }
    renderAccessories(items) {
      const target=this.querySelector('.vo-accessories');target.replaceChildren();if(!items.length)return;
      target.append(this.el('h3',this.t.extras));items.forEach(item=>{const a=this.el('a',`${item.title} · ${item.price}`);a.href=item.product_kind==='greeting_card'?this.dataset.cart:this.localProduct(item.handle);target.append(a,this.el('p',item.product_kind==='greeting_card'?this.t.card_note:item.note,'vo-small'))});
    }
    async addToCart(button,r) {
      if(button.disabled || this.cartBusy)return;this.cartBusy=true;button.disabled=true;let added=false;
      try {
        const id=Number(r.variant_id),qty=Number(r.requested_quantity||1);if(!Number.isSafeInteger(id)||id<=0||!Number.isInteger(qty)||qty<1)throw Error(this.t.cart_error);
        const response=await fetch((this.dataset.cartAdd||'/cart/add').replace(/\.js$/,'')+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:qty}],sections:['helper-cart'],sections_url:location.pathname})});
        const payload=await response.json();if(!response.ok||payload.status>=400)throw Error(typeof payload.description==='string'?payload.description:this.t.cart_error);
        added=true;button.textContent=this.t.cart_success;this.status.textContent=this.t.cart_success;
        const html=payload.sections?.['helper-cart'];if(!html)throw Error('section');
        const parsed=new DOMParser().parseFromString(html,'text/html');
        for(const id of ['AjaxCartForm','AjaxCartSubtotal']){const old=document.getElementById(id),next=parsed.getElementById(id);if(!old||!next)throw Error('markup');old.innerHTML=next.innerHTML;old.ajaxifyCartItems?.()}
        for(const [target,source] of [['[data-header-cart-count]','[data-cart-count]'],['[data-header-cart-total]','[data-cart-total]']]){const val=parsed.querySelector(source)?.textContent;if(val!==undefined)document.querySelectorAll(target).forEach(el=>el.textContent=val)}
        // Keep the consultation open; the customer chooses when to view the cart.
      } catch(error) {
        if(added){this.status.textContent=this.t.cart_success;}else{this.status.textContent=error.message||this.t.cart_error;button.textContent=this.t.cart_add}
      } finally {this.cartBusy=false;button.disabled=button.dataset.unavailable==='true'}
    }
    contact(show) {this.querySelector('.vo-contact').hidden=!show;this.updateDock();if(show){this.updateContactHours();this.dataset.pose='welcome';this.speech.textContent=this.t.contact_intro;this.bottom()}}
    updateContactHours(now = new Date()) {
      const parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Berlin', weekday:'short', hour:'2-digit', minute:'2-digit', hourCycle:'h23'}).formatToParts(now);
      const part = name => parts.find(p => p.type === name)?.value;
      const minutes = Number(part('hour')) * 60 + Number(part('minute'));
      const open = ['Mon','Tue','Wed','Thu','Fri'].includes(part('weekday')) && minutes >= 540 && minutes < 990;
      this.querySelector('[data-chat-note]').textContent = open ? this.t.chat_during_hours : this.t.chat_after_hours;
      this.querySelector('[data-action="livechat"]').textContent = open ? this.t.chat : this.t.chat_leave_message;
    }
    openChat() {
      const widget = window.Trengo?.Api?.Widget;
      if (typeof widget?.open === 'function') {
        try { this.chatHandoff = true; this.dialog.close(); widget.open('chat'); return; } catch { this.open(); }
      }
      this.status.textContent = this.t.chat_unavailable;
      this.contact(true);
    }
    startDuel() {this.begin();this.dueling=true;this.dataset.dueling='true';this.updateDock();this.duelRound=0;this.duelAnswers=[];this.form.hidden=true;this.renderDuel()}
    renderDuel() {
      const box=this.querySelector('.vo-duel');box.hidden=false;box.replaceChildren();this.dataset.pose='question';this.speech.textContent=this.t.duel_intro;
      const category=this.duelAnswers[0];
      const q=this.duelRound===0?'type':this.duelRound===1?(category==='red'?'red':category==='sparkling'?'sparkling':'light'):'budget';
      box.append(this.el('p',`${this.t.round} ${this.duelRound+1} / 2`,'vo-small'),this.el('h3',this.t['duel_'+q]));
      const values=q==='type'?['red','white','rose','sparkling']:q==='red'?['soft','bold']:q==='sparkling'?['fresh','creamy']:q==='light'?['fresh','round']:['10','15','25','open'];
      const options=this.el('div',null,'vo-duel-options');for(const value of values){const b=this.button(this.t['choice_'+value],'choice');b.dataset.choice=value;options.append(b)}box.append(options);
      if(this.duelRound===1){const skip=this.button(this.t.unsure,'choice');skip.dataset.choice='unsure';box.append(skip)}
      if(this.duelRound>0)box.append(this.button(this.t.back,'duel-back'));
      box.append(this.button(this.t.duel_cancel,'duel-cancel'));this.bottom();
    }
    chooseDuel(value) {
      this.duelAnswers[this.duelRound]=value;this.duelRound++;
      if(this.duelRound<2){this.renderDuel();return}
      const labels=this.duelAnswers.map(x=>this.t['choice_'+x]||this.t.unsure);
      const summary = this.t.duel_request + ' ' + labels.join(' · ');
      this.send(summary + '. ' + this.t.duel_context, false, false, summary);
    }
  });
})();



